{
  "showAllButtonLabel": "Show all ({tagCount, number})",
  "hideButtonLabel": "Show less",
  "actions": "Actions",
  "noTags": "None"
}
